import { Col, Layout, Row, Spin, Table, Tag } from 'antd';
import axios from 'axios';
import 'moment-timezone';
import React, { Component } from 'react';
import Moment from 'react-moment';
import { connect } from 'react-redux';
import { Constant } from '../../config';
import { GatewayColor, GatewayName } from '../../config/gateway';
import { fetchMenuAction } from '../../store/actions/leftSideMenu';
import SearchForm from '../SearchForm';
import moment from 'moment-timezone';

const { Content } = Layout;

Moment.globalLocal = false;

class DeliveryLogsVerify extends Component {
  state = {
    currentPage: 1,
    currentSearch: '',
    currentRangeDate: [],
    dataSource: [],
    loading: false,
    totalRows: 0,
  };

  columns = [
    {
      align: 'center',
      dataIndex: 'created',
      render: (created) => {
        if (!created) return '-';

        return (
          <Moment unix tz="Etc/UTC" format="MMM DD YYYY HH:mm">
            {created}
          </Moment>
        );
      },
      title: 'Date / Time',
      width: '150px',
    },
    {
      align: 'center',
      dataIndex: 'member_id',
      render: (_, record) => {
        return record.member_detail ? record.member_detail.email || '-' : '-';
      },
      title: 'Email',
      width: '150px',
    },
    {
      align: 'center',
      dataIndex: 'phone',
      render: (phone, record) => {
        return (
          <span>
            <span>{phone}</span>
            <br />
            <Tag color="brown">{record.receiver_country || '-'}</Tag>
          </span>
        );
      },
      title: 'Phone No.',
      width: '150px',
    },
    {
      dataIndex: 'text',
      render: (text, record) => {
        return (
          <span>
            <span>{text}</span>
            <br />
            <Tag color="orange" style={{ marginBottom: '8px' }}>
              Sender: {record.sender_name || '-'}
            </Tag>
            <br />
            <Tag color="blue" style={{ marginBottom: '8px' }}>
              Message ID: {record.message_id || '-'}
            </Tag>
            <br />
          </span>
        );
      },
      title: 'Message',
      width: '400px',
    },
    {
      align: 'center',
      dataIndex: 'status',
      render: (status) => {
        return this.getStatus(status);
      },
      title: 'Status',
      width: '100px',
    },
    {
      dataIndex: 'sms_gateway_id',
      render: (_, record) => {
        const gateway = record.sms_gateway_detail || {};

        return (
          <span>
            {this.getGateway(gateway.key_name || '')}
            <span>{record.sms_gateway_msg_id || '-'}</span>
            <br />
            <Tag style={{ marginBottom: '8px' }}>
              {record.sms_gateway_dn_response || '-'}
            </Tag>
            <br />
            <Tag color="cyan">Client rate: {record.client_rate_sms || '-'}</Tag>
            <Tag color="green">Market rate: {record.market_rate_sms || '-'}</Tag>
          </span>
        );
      },
      title: 'SMS Gateway',
    },
    {
      align: 'center',
      dataIndex: 'sms_status',
      render: (smsStatus) => {
        return this.getStatus(smsStatus);
      },
      title: 'SMS Status',
      width: '100px',
    },
    {
      dataIndex: 'voice_gateway_id',
      render: (_, record) => {
        const gateway = record.voice_gateway_detail || {};

        return (
          <span>
            <Tag style={{ marginBottom: '8px' }}>{gateway.name || '-'}</Tag>
            <span>{record.voice_gateway_msg_id || '-'}</span>
            <br />
            <Tag color="cyan">Client rate: {record.client_rate_verify_sms || '-'}</Tag>
          </span>
        );
      },
      title: 'Voice Gateway',
    },
    {
      align: 'center',
      dataIndex: 'voice_status',
      render: (voiceStatus) => {
        return this.getStatus(voiceStatus);
      },
      title: 'Voice Status',
      width: '100px',
    },
  ];
  _columns = [
    {
      title: 'Phone No.',
      dataIndex: 'phone',
      render: (text, record) => {
        return (
          <span>
            <span style={{ fontWeight: 'bold' }}>{record.phone}</span> <br />
            <Tag color="brown">{record.receiver_country}</Tag>
          </span>
        );
      },
    },
    {
      title: 'Message ID',
      dataIndex: 'message_id',
      render: (text, record) => {
        return (
          <span>
            <span style={{ fontWeight: 'bold' }}>{record.message_id}</span>
          </span>
        );
      },
    },
    {
      title: 'Sender',
      dataIndex: 'sender',
      render: (text, record) => {
        let member_id = '';
        if (record.member_id !== '' && record.member_id != null) {
          member_id = (
            <div>
              <Tag color="blue">ID: {record.member_id}</Tag>
            </div>
          );
        }
        let email = '';
        if (record.member_email !== '' && record.email != null) {
          email = (
            <div>
              <Tag color="blue">Email: {record.member_email}</Tag>
            </div>
          );
        }
        return (
          <span>
            <div style={{ fontWeight: 'bold' }}>{record.sender_name}</div>
            {member_id}
            {email}
            <Tag color="pink">
              created:
              <Moment unix tz="Etc/UTC" format="MMM DD YYYY HH:mm:ss">
                {record.created}
              </Moment>
            </Tag>
            <br />
            <Tag color="pink">
              updated:
              <Moment unix tz="Etc/UTC" format="MMM DD YYYY HH:mm:ss">
                {record.updated}
              </Moment>
            </Tag>
          </span>
        );
      },
    },
    {
      title: 'Status',
      dataIndex: 'status',
      render: (text, record) => {
        return (
          <span>
            {this.getStatus(record.status)} <br />
          </span>
        );
      },
    },
    {
      title: 'SMS',
      dataIndex: 'sms',
      render: (text, record) => {
        return (
          <span>
            <Tag>Gateway Msg ID: {record.sms_gateway_msg_id}</Tag>
            <br />
            <Tag>Gateway DN Response: {record.sms_gateway_dn_response}</Tag>
            <br />
            <Tag width="100">Text: {record.text}</Tag>
            <br />
            <Tag color="pink">
              sent date:
              <Moment unix tz="Etc/UTC" format="MMM DD YYYY HH:mm:ss">
                {record.sms_sent_date}
              </Moment>
            </Tag>
            <br />
            <Tag color="pink">
              ack date:
              <Moment unix tz="Etc/UTC" format="MMM DD YYYY HH:mm:ss">
                {record.sms_ack_date}
              </Moment>
            </Tag>
            <br />
            {this.getGateway(record.sms_gateway)}
            <br />
            {this.getStatus(record.sms_status)}
          </span>
        );
      },
    },
    {
      title: 'VOICE',
      dataIndex: 'voice',
      render: (text, record) => {
        if (record.is_voice_sent === 1) {
          return (
            <span>
              <Tag>Gateway Msg ID: {record.voice_gateway_msg_id}</Tag>
              <br />
              <Tag>Gateway DN Response: {record.voice_gateway_dn_response}</Tag>
              <br />
              <Tag width="100">Text: {record.text_to_speech}</Tag>
              <br />
              <Tag color="pink">
                sent date:
                <Moment unix tz="Etc/UTC" format="MMM DD YYYY HH:mm:ss">
                  {record.voice_sent_date}
                </Moment>
              </Tag>
              <br />
              <Tag color="pink">
                ack date:
                <Moment unix tz="Etc/UTC" format="MMM DD YYYY HH:mm:ss">
                  {record.voice_ack_date}
                </Moment>
              </Tag>
              <br />
              {this.getGateway(record.voice_gateway)}
              <br />
              {this.getStatus(record.voice_status)} <br />
            </span>
          );
        } else {
          return <span>N/A</span>;
        }
      },
    },
  ];
  columnsMobile = [];
  limit = 10;

  componentWillMount() {
    this.props.fetchMenuAction('sms-logs', 'verify');
  }

  changePage = async (page) => {
    this.setState({
      currentPage: page,
      loading: true,
    });

    await this.getDataList(page, this.state.currentSearch);

    this.setState({ loading: false });
  };

  getDataList = async (page = 1, search = '', rageDate = []) => {
    let resp;
    const token = localStorage.getItem(Constant.SessionKey);
    const url = `${Constant.DELIVERY_LOGS_VERIFY_API}`;
    const opt = {
      headers: { Authorization: `Bearer ${token}` },
      method: 'GET',
      params: { 
        page, 
        limit: this.limit, 
        search,
        start_date: moment(rageDate[0]).format("YYYY-MM-DD"),
        end_date: moment(rageDate[1]).format("YYYY-MM-DD"),
      },
      url,
    };

    try {
      resp = await axios(opt);

      if (!resp.data) throw new Error("Response key 'data' is undefined.");
    } catch (e) {
      console.error(e);
      this.initialState();
      return;
    }

    this.setState({
      currentPage: resp.data.page || 1,
      dataSource: resp.data.data || [],
      loading: false,
      totalRows: resp.data.total_rows || 0,
    });
  };

  getStatus(status) {
    let color = '';
    let keyName = '-';

    if (status) {
      switch (status) {
        case 'S':
          color = 'green';
          keyName = 'Sucess';
          break;
        case 'F':
          color = 'red';
          keyName = 'Failed';
          break;
        case 'E':
          color = 'blue';
          keyName = 'Expired';
          break;
        case 'I':
          color = 'orange';
          keyName = 'Inprocess';
          break;
        case 'WA':
          color = 'purple';
          keyName = 'Wait for acknowledge';
          break;
        case 'CA':
          color = 'yellow';
          keyName = 'Cancelled';
          break;
        case 'N':
          color = '';
          keyName = 'None';
          break;
        case 'UNUSED':
          color = 'cyan';
          keyName = 'Unused';
          break;
        case 'B':
          color = '#524b50';
          keyName = 'Blacklist';
          break;
        default:
      }
    }

    return <Tag color={color}>{keyName}</Tag>;
  }

  getGateway = (gateway) => (
    <Tag color={GatewayColor(gateway)} style={{ marginBottom: '8px' }}>
      {GatewayName(gateway)}
    </Tag>
  );

  mySearch = (fd) => {
    fd.validateFields(async (err, values) => {
      if (err) return;

      const rangeDate = values.range_date || []

      this.setState({
        currentPage: 1,
        currentSearch: values.searchTxt,
        currentRangeDate: rangeDate,
        loading: true,
      });

      await this.getDataList(1, values.searchTxt, rangeDate);

      this.setState({ loading: false });
    });
  };

  resetSearch = async () => {
    this.setState({
      currentPage: 1,
      currentSearch: '',
      currentRangeDate: [],
      dataSource: [],
      totalRows: 0,
    });
  };

  render() {
    let propsTable = {
      className: 'my-table',
      columns: this.columns,
      dataSource: this.state.dataSource,
      rowKey: 'id',
      pagination: {
        pageSize: this.state.limit,
        total: this.state.totalRows,
        current: this.state.currentPage,
        onChange: this.changePage,
        size: 'small',
      },
      size: 'small',
      scroll: {
        x: 1700,
      },
    };

    return (
      <Layout className="my-layout">
        <Spin spinning={this.state.loading} tip="กำลังโหลดข้อมูล...">
          <Content
            style={{
              background: '#fff',
              padding: 24,
              margin: '16px 0',
              minHeight: 300,
              scrollBehavior: 'smooth',
            }}
          >
            <h2>Delivery Log Verify</h2>
            <p className="header-desc">บันทึกรายการ Verify</p>
            <Row className="utility-bar">
              <Col span={24}>
                <SearchForm
                  fn={this.mySearch}
                  fnReset={this.resetSearch}
                  placeholder="Email, Message ID, Phone No."
                  width="300px"
                  isShowRangeDate={true}
                />
              </Col>
            </Row>
            <Row className="utility-bar-mobile">
              <SearchForm fn={this.mySearch} fnReset={this.resetSearch} />
            </Row>
            <Table {...propsTable} />
          </Content>
        </Spin>
      </Layout>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchMenuAction: (menuParentKey, menuKey) =>
      dispatch(fetchMenuAction(menuParentKey, menuKey)),
  };
};

export default connect(null, mapDispatchToProps)(DeliveryLogsVerify);



// WEBPACK FOOTER //
// ./src/containers/DeliveryLogsVerify/index.js